import { useState } from "react";
import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { errorMessage } from "../../lib/api";

// The club's sign-in, sat over their games. The room itself is open to anyone — the games behind this
// are not. Signing in uses the player's Players Room account; the club's branding is on the door.
export const ClubGate = ({ club }) => {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, pw);
    } catch (x) {
      setErr(errorMessage(x));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="absolute inset-0 z-20 flex items-center justify-center p-4" data-testid="club-gate"
      style={{ background: "color-mix(in srgb, var(--c-ground) 72%, transparent)", backdropFilter: "blur(8px)", WebkitBackdropFilter: "blur(8px)" }}>
      <form onSubmit={submit} className="club-panel w-full max-w-sm p-6 flex flex-col gap-4 club-rise"
        data-testid="club-gate-form">
        <span className="club-bulbs club-bulbs-top" />
        <img src={club.logo} alt={club.name} className="h-10 object-contain self-center" />
        <div className="flex flex-col items-center gap-1">
          <span className="club-display text-xl uppercase club-neon">Member sign-in</span>
          <span className="text-[11px] club-soft text-center">
            Sign in to see {club.short}'s games and take your seat.
          </span>
        </div>
        <label className="text-xs club-soft">Email
          <input data-testid="club-gate-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
            className="club-input mt-1 w-full px-3 py-2 text-sm" />
        </label>
        <label className="text-xs club-soft">Password
          <input data-testid="club-gate-password" value={pw} onChange={(e) => setPw(e.target.value)} type="password" required
            className="club-input mt-1 w-full px-3 py-2 text-sm" />
        </label>
        {err && <div data-testid="club-gate-error" className="text-xs text-red-400">{err}</div>}
        <button type="submit" disabled={busy} data-testid="club-gate-submit"
          className="club-btn px-6 py-2.5 text-xs uppercase tracking-[0.2em] gap-2 disabled:opacity-50">
          <LogIn className="w-3.5 h-3.5" /> {busy ? "Signing in…" : "Sign in"}
        </button>
        <Link to="/" data-testid="club-gate-join" className="text-[11px] club-soft text-center underline underline-offset-4">
          No account yet? Join Players Room
        </Link>
      </form>
    </div>
  );
};
